module.exports = __webpack_public_path__ + "static/lframe-pay-any-way-b0550e466385abaef4618c3841afc3d3.png";